module.exports = {"440111002":"三元里街道","440111003":"松洲街道","440111004":"景泰街道","440111005":"同德街道","440111006":"黄石街道","440111007":"棠景街道","440111008":"新市街道","440111009":"同和街道","440111010":"京溪街道","440111011":"永平街道","440111012":"嘉禾街道","440111013":"均禾街道","440111014":"石井街道","440111015":"金沙街道","440111016":"云城街道","440111017":"鹤龙街道","440111018":"白云湖街道","440111019":"石门街道","440111103":"人和镇","440111107":"太和镇","440111108":"钟落潭镇","440111113":"江高镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/440111.json
// module id = 1949
// module chunks = 0